import { render, staticRenderFns } from "./VueAuthLandingFooter.vue?vue&type=template&id=9bd67912&"
import script from "./VueAuthLandingFooter.vue?vue&type=script&lang=js&"
export * from "./VueAuthLandingFooter.vue?vue&type=script&lang=js&"
import style0 from "./VueAuthLandingFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports